/**
 * app标识
 */
export enum AppType {
  HOSE = 'HOSE',
  HWHT = 'HWHT',
  ESIGN = 'ESIGN',
  FEISHU = 'FEISHU',
  DATABASE = 'DATABASE',
  KINGDEE = 'KINGDEE',
  KINGDEE_CLIENT = 'KINGDEE_CLIENT',
  DINGTALK = 'DINGTALK',
  JST = 'JST',
  ZJZ = 'ZJZ',
  ETEAMS = 'ETEAMS',
  YUNZJ = 'YUNZJ',
  BEISEN = 'BEISEN',
  QIYUESUO = 'QIYUESUO',
  SAAS_QIYUESUO = 'SAAS_QIYUESUO',
  NUONUO = 'NUONUO',
  DIANDANG = 'DIANDANG',
  SEEYON = 'SEEYON',
  SEEYON_EHR = 'SEEYON_EHR',
  DIDI = 'DIDI',
  WANGSHANGBANK = 'WANGSHANGBANK',
  XRXS = 'XRXS',
  GBZC = 'GBZC',
  XSY = 'XSY',
  HOSE_EKB_PAY = 'HOSE_EKB_PAY',
  ORACLE_DATABASE = 'ORACLE_DATABASE',
  FXXK = 'FXXK',
}

/**
 * 页面嵌入来源
 */
export enum IframeParent {
  USER = "user",
  Admin = "admin"
}
